var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.27813 0 0 6.27813 0 14C0 21.7219 6.27813 28 14 28C21.7219 28 28 21.7219 28 14C28 6.27813 21.7219 0 14 0Z",
    fill: "#57AB69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3039 20.4039C9.51562 18.6156 7.73828 16.8109 5.94453 15.0226C5.74766 14.8257 5.74766 14.4976 5.94453 14.3007L8.00625 12.239C8.20312 12.0421 8.53125 12.0421 8.72813 12.239L11.6758 15.1867L19.2555 7.60151C19.4578 7.40464 19.7805 7.40464 19.9828 7.60151L22.05 9.6687C22.2523 9.87104 22.2523 10.1937 22.05 10.3906L12.0258 20.4039C11.8289 20.6062 11.5062 20.6062 11.3039 20.4039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.1d424b56f3f4a9d31b4bf2264bae2f5f.svg";
export { ForwardRef as ReactComponent };